export function replacePlaceholders(string, replacements) {
  return string.replace(/{(\w+)}/g, (delimiters, withoutDelimiters) => {
    return replacements[withoutDelimiters] || delimiters
  })
}

export function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}
